import { tokenManager } from '@/services/api';

export interface TokenRoleInfo {
  userType: 'member' | 'user' | null;
  roleLevel: number;
}

/** JWT payload 디코드 (검증 없음 — 클라이언트 표시·권한 보조용) */
export function parseJwtPayload(token: string): Record<string, unknown> | null {
  try {
    const parts = token.split('.');
    if (parts.length < 2) return null;
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const json = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
        .join('')
    );
    return JSON.parse(json) as Record<string, unknown>;
  } catch {
    return null;
  }
}

/** 토큰에 담긴 실제 로그인 주체 권한 (기관 대리 화면에서 store와 불일치 시 사용) */
export function getTokenRoleInfo(): TokenRoleInfo {
  const token = tokenManager.getToken();
  if (!token) return { userType: null, roleLevel: 0 };

  const payload = parseJwtPayload(token);
  if (!payload) return { userType: null, roleLevel: 0 };

  const userType =
    payload.userType === 'user' || payload.userType === 'member'
      ? payload.userType
      : null;
  const roleLevel = Number(payload.roleLevel) || 0;

  return { userType, roleLevel };
}

/** JWT exp(초) → ms. 없거나 파싱 실패 시 null */
export function getJwtExpiresAtMs(token: string | null | undefined): number | null {
  if (!token) return null;
  const payload = parseJwtPayload(token);
  const exp = Number(payload?.exp);
  if (!Number.isFinite(exp) || exp <= 0) return null;
  return exp * 1000;
}

/** access JWT가 아직 쓸 만하면 true (기본: 만료 10분 이상 남음) */
export function isAccessTokenFresh(
  token: string | null | undefined,
  skewMs: number = 10 * 60 * 1000
): boolean {
  const expMs = getJwtExpiresAtMs(token);
  if (expMs == null) return false;
  return expMs - Date.now() > skewMs;
}

export function isAccessTokenExpired(token: string | null | undefined): boolean {
  const expMs = getJwtExpiresAtMs(token);
  if (expMs == null) return true;
  return expMs <= Date.now();
}
